function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-109bf81e\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Indicator.vue")
}
var Component = require("!../../../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Indicator.vue"),
  /* template */
  require("!!../../../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-109bf81e\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Indicator.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-109bf81e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/components/indicator/Indicator.vue
// module id = 87000c9f4bfb17496d15
// module chunks = 89